/**
 * BlumeAdmin UI Actions
 *
 * Actions for managing the BlumeAdmin UI state including side menu expansion
 * and other UI-related settings for the Blume Admin section.
 */

/**
 * Initialize BlumeAdmin UI State Action
 *
 * Dispatched when the Blume Admin route is first accessed.
 * Loads the UI state from localStorage if available.
 *
 * @example
 * this.store.dispatch(new InitializeBlumeAdminUIStateAction());
 */
export class InitializeBlumeAdminUIStateAction {
  static readonly type = '[BlumeAdmin UI] Initialize State';
}

/**
 * Set BlumeAdmin Side Menu Expanded Action
 *
 * Sets the side menu expansion state to a specific value.
 *
 * @param expanded - Whether the side menu should be expanded
 *
 * @example
 * // Expand side menu
 * this.store.dispatch(new SetBlumeAdminSideMenuExpandedAction(true));
 *
 * @example
 * // Collapse side menu
 * this.store.dispatch(new SetBlumeAdminSideMenuExpandedAction(false));
 */
export class SetBlumeAdminSideMenuExpandedAction {
  static readonly type = '[BlumeAdmin UI] Set Side Menu Expanded';
  constructor(public expanded: boolean) {}
}

/**
 * Toggle BlumeAdmin Side Menu Expanded Action
 *
 * Toggles the current side menu expansion state.
 * If expanded, it will be collapsed, and vice versa.
 *
 * @example
 * this.store.dispatch(new ToggleBlumeAdminSideMenuExpandedAction());
 */
export class ToggleBlumeAdminSideMenuExpandedAction {
  static readonly type = '[BlumeAdmin UI] Toggle Side Menu Expanded';
}

